import { Avatar, Box, CardHeader, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const CommentInputContainer = styled(Box)({
    backgroundColor: "var(--community-color-snow-white)",
    width: "100%",
    margin: "0 auto",
    gap: "12px",
    padding: "8px 12px",
    flexDirection: "column",
    cursor: "pointer",
    zIndex: 2,
    left: 0,
    right: 0,
    borderTop: "1px solid var(--community-color-dark-gray)",
    "@media (min-width: 640px)": {
        borderBottomRightRadius: "12px",
        borderBottomLeftRadius: "12px",
    },
});

export const HeadlinePostInput = styled(Box)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    width: "36px",
    height: "36px",
    borderRadius: "90px",
    marginLeft: "12px",
    backgroundColor: "var(--community-color-transparent-black-05)",
    "& > svg": {
        width: "20px",
        height: "20px",
    },
    "& > p": {
        fontSize: "14px",
        fontWeight: "500",
        color: "var(--community-color-primary-text)",
    },
});

export const AvatarCardHeader = styled(CardHeader)({
    alignItems: "flex-start",
    padding: "0",
    "& > .MuiCardHeader-avatar": {
        marginRight: "12px",
    },
});

export const HeadlineTeaserBoxTypography = styled(Typography)({
    justifyContent: "left",
    textTransform: "none",
    fontWeight: "normal",
    fontSize: "14px",
    color: "var(--community-color-secondary-text)",
    textWrap: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
});

export const HeadlineTeaserAvatar = styled(Avatar)({
    width: "36px",
    height: "36px",
});

export const HeadlineTeaserAvatarSkeleton = styled(Skeleton)({
    width: "36px",
    height: "36px",
    marginRight: "12px",
});
